import { API } from "@/lib/axios";
import { TColor } from "@/types/color";
import { AxiosResponse } from "axios";

const ENTITY = "/color";

export const getList = async (): Promise<AxiosResponse<{ data: { items: TColor[] } }>> => API.get(`${ENTITY}/list`);
